<template>
  <div class="modal-atom">
    <div class="modal-atom__content" :class="contentClasses">
      <svg class="modal-atom__content__close" @click="$emit('close')" v-if="showClose">
        <use xlink:href="#cross"></use>
      </svg>
      <h1 class="modal-atom__title">{{ title }}</h1>
      <slot name="content" />
      <div class="modal-atom__content__footer">
        <div class="modal-atom__content__footer__buttons">
          <slot name="buttons" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      validator: (val) => {
        return ['xs', 'sm', 'md', 'lg', 'xl'].includes(val);
      },
      default: 'md',
    },
  },
  computed: {
    contentClasses() {
      return ['modal-atom__content--' + this.size];
    },
  },
  emits: ['close'],
};
</script>

<style scoped>
.sgf-ace .modal-atom {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.sgf-ace .modal-atom__content {
  display: flex;
  flex-direction: column;
  border-top: 4px solid var(--ace-c-primary-blue);
  padding: 40px;
  padding-right: 48px;
  background-color: var(--ace-c-primary-white);
  border-radius: 5px;
  max-height: 75%;
  position: relative;
  overflow-y: auto;
}
.sgf-ace .modal-atom__content--xs {
  width: 15%;
}

.sgf-ace .modal-atom__content--sm {
  width: 25%;
}

.sgf-ace .modal-atom__content--md {
  width: 50%;
}

.sgf-ace .modal-atom__content--lg {
  width: 75%;
}

.sgf-ace .modal-atom__content--xl {
  width: calc(100% - 200px);
}

.sgf-ace .modal-atom__content__close {
  position: absolute;
  cursor: pointer;
  width: 15px;
  height: 15px;
  right: 22px;
  top: 15px;
}

.sgf-ace .modal-atom__title {
  margin-top: 8px;
  margin-bottom: 8px;
  font-family: 'BrixSansBlack';
  font-size: 24px;
  line-height: 30px;
}

.sgf-ace .modal-atom__content__footer {
  display: flex;
  flex-direction: row;
}

.sgf-ace .modal-atom__content__footer__buttons {
  display: flex;
  flex-direction: row-reverse;
  flex-grow: 1;
  gap: 4px;
}

@media (max-width: 992px) {
  .sgf-ace .modal-atom__content--sm {
    width: 80%;
  }
  .sgf-ace .modal-atom__content {
    padding: 16px;
  }
}
</style>
